import { Table, TableBody, TableCell, TableRow, Tooltip } from '@mui/material'
import cn from 'classnames'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Link from '../common/util/input/Link'
import {
    extractAssetData,
    formatNumber,
    formatWAX,
    getOwnerLink,
} from '../helpers/FormatLinks'

import { Accordion, AccordionItem } from '@nextui-org/react'
import MarketPreviewDetailsTable from '../assetpreview/MarketPreviewDetailsTable'

const AssetDetails = (props) => {
    const asset = props.asset
    const newOwner = props.newOwner

    let {
        name,
        owner,
        assetId,
        collection,
        schema,
        template,
        createdAt,
        mint,
        price,
        seller,
        burned,
        contract,
        backedTokens,
    } = asset

    const { mData, iData, tData } = extractAssetData(asset)

    const { t } = useTranslation('common')

    const date = createdAt ? createdAt.date : ''

    const initialOpenItems = () => {
        const openItems = new Map()
        openItems.set(t('asset.details'), true)
        openItems.set(t('asset.immutable_data'), true)
        openItems.set(t('asset.mutable_data'), true)
        openItems.set(t('search.market'), true)
        openItems.set('Bids', true)
        return openItems
    }

    const [toggleItem, setToggleItem] = useState(initialOpenItems())

    let attributeName = ''
    const attributeSearch = attributeName
        ? `&attributes=${escape(attributeName)}:${escape(value)}`
        : ''

    return (
        <div
            className={cn(
                'border dark:!bg-paper bg-white rounded-md shadow-xl',
                'dark:!border-paperl border-zinc-200 p-4 ml-0 lg:ml-4 mt-4 w-auto',
            )}
        >
            <Accordion
                className="px-0"
                defaultExpandedKeys={['1', '2']}
                disableAnimation={false}
                disableIndicatorAnimation={false}
                hideIndicator={false}
                isCompact={false}
                isDisabled={false}
            >
                <AccordionItem
                    classNames={{
                        trigger:
                            'px-4 py-2 my-1 rounded-lg dark:bg-zinc-800 bg-zinc-200 font-semibold',
                    }}
                    key="1"
                    title={t('asset.details')}
                    toggleItem={toggleItem}
                    setToggleItem={setToggleItem}
                >
                    <Table size="small">
                        <TableBody>
                            <TableRow>
                                <TableCell>{t('asset.asset_id')}</TableCell>
                                <TableCell>
                                    <Link
                                        className={
                                            'text-primary hover:underline cursor-pointer break-all'
                                        }
                                        href={`/asset/${assetId}`}
                                    >
                                        {assetId}
                                    </Link>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>{t('asset.contract')}</TableCell>
                                <TableCell>
                                    <Link
                                        external={true}
                                        className={
                                            'text-primary hover:underline cursor-pointer break-all'
                                        }
                                        href={`https://waxblock.io/account/${contract}`}
                                    >
                                        {contract}
                                    </Link>
                                </TableCell>
                            </TableRow>
                            {template?.templateId &&
                            template?.templateId > 0 ? (
                                <TableRow>
                                    <TableCell>
                                        {t('asset.template_id')}
                                    </TableCell>
                                    <TableCell>
                                        <Link
                                            className={
                                                'text-primary hover:underline cursor-pointer break-all'
                                            }
                                            href={`/template/${template?.templateId}`}
                                        >
                                            {template?.templateId}
                                        </Link>
                                    </TableCell>
                                </TableRow>
                            ) : (
                                ''
                            )}
                            {template?.templateId &&
                            template?.templateId > 0 ? (
                                <TableRow>
                                    <TableCell>
                                        {t('asset.max_supply')}
                                    </TableCell>
                                    <TableCell>
                                        {template?.maxSupply
                                            ? template?.maxSupply
                                            : 0}
                                    </TableCell>
                                </TableRow>
                            ) : (
                                ''
                            )}
                            <TableRow>
                                <TableCell>{t('asset.name')}</TableCell>
                                <TableCell>{name}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>{t('asset.mint')}</TableCell>
                                <TableCell>#{mint}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    {t('asset.number_of_assets')}
                                </TableCell>
                                <TableCell>
                                    <div className="inline-flex leading-6">
                                        {template?.stats?.numMinted ? (
                                            <Tooltip
                                                title={t('asset.available')}
                                            >
                                                <Link
                                                    className={
                                                        'text-primary hover:underline cursor-pointer break-all'
                                                    }
                                                    href={`/collection/${
                                                        collection.collectionName
                                                    }?tab=assets&term=${escape(
                                                        template?.templateId
                                                            ? template.templateId
                                                            : name,
                                                    )}&schema=${schema}&exact_search=true&on_sale=false&search_type=assets`}
                                                    rel="noreferrer"
                                                >
                                                    {template.stats.numMinted -
                                                        (template.stats
                                                            .numBurned
                                                            ? template.stats
                                                                  .numBurned
                                                            : 0)}
                                                </Link>
                                            </Tooltip>
                                        ) : (
                                            ''
                                        )}
                                    </div>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>{t('asset.burned')}</TableCell>
                                <TableCell>
                                    <div className="inline-flex leading-6">
                                        {template?.stats?.numBurned ? (
                                            <Tooltip
                                                title={t('asset.available')}
                                            >
                                                <Link
                                                    className={
                                                        'text-primary hover:underline cursor-pointer break-all'
                                                    }
                                                    href={`/collection/${
                                                        collection.collectionName
                                                    }?tab=assets&term=${escape(
                                                        template?.templateId
                                                            ? template.templateId
                                                            : name,
                                                    )}&schema=${schema}&exact_search=true&on_sale=false&search_type=burned`}
                                                    rel="noreferrer"
                                                >
                                                    {template.stats.numBurned}
                                                </Link>
                                            </Tooltip>
                                        ) : (
                                            ''
                                        )}
                                    </div>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>{t('asset.owner')}</TableCell>
                                <TableCell>
                                    {burned
                                        ? `🔥`
                                        : getOwnerLink(
                                              newOwner
                                                  ? newOwner
                                                  : price
                                                  ? seller
                                                  : owner,
                                          )}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>{t('asset.schema')}</TableCell>
                                <TableCell>
                                    <Link
                                        className={
                                            'text-primary hover:underline cursor-pointer break-all'
                                        }
                                        href={`/collection/${collection.collectionName}/${schema}`}
                                    >
                                        {schema}
                                    </Link>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>{t('asset.created')}</TableCell>
                                <TableCell>{date}</TableCell>
                            </TableRow>
                            {backedTokens ? (
                                <TableRow>
                                    <TableCell>
                                        {t('asset.backed_tokens')}
                                    </TableCell>
                                    <TableCell>
                                        {backedTokens.map((token) => (
                                            <span className={'mr-1'}>
                                                {token}
                                            </span>
                                        ))}
                                    </TableCell>
                                </TableRow>
                            ) : (
                                ''
                            )}
                        </TableBody>
                    </Table>
                </AccordionItem>
            </Accordion>

            {template?.stats ? (
                <Accordion
                    className="px-0"
                    defaultExpandedKeys={['2']}
                    disableAnimation={false}
                    disableIndicatorAnimation={false}
                    hideIndicator={false}
                    isCompact={false}
                    isDisabled={false}
                >
                    <AccordionItem
                        title={t('search.market')}
                        toggleItem={toggleItem}
                        setToggleItem={setToggleItem}
                        classNames={{
                            trigger:
                                'px-4 py-2 my-1 rounded-lg dark:bg-zinc-800 bg-zinc-200 font-semibold',
                        }}
                        key="2"
                    >
                        <Table size="small">
                            <TableBody>
                                {/* Median */}
                                {template.stats['averageWaxPrice'] ? (
                                    <TableRow>
                                        <TableCell>
                                            {t('asset.average_bought')}
                                        </TableCell>
                                        <TableCell>
                                            {template.stats['averageWaxPrice']
                                                ? `${formatWAX(
                                                      template.stats[
                                                          'averageWaxPrice'
                                                      ],
                                                  )}`
                                                : null}
                                            {template.stats['averageUsdPrice']
                                                ? ` / $${formatNumber(
                                                      template.stats[
                                                          'averageUsdPrice'
                                                      ],
                                                  )}`
                                                : '-'}
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    ''
                                )}
                                {/* Amount Sold */}
                                {template.stats['numSales'] ? (
                                    <TableRow>
                                        <TableCell>
                                            {t('asset.num_sales')}
                                        </TableCell>
                                        <TableCell>
                                            {template.stats['numSales']}
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    ''
                                )}
                                {/* Floor */}
                                {template.stats['floorPrice'] ? (
                                    <TableRow>
                                        <TableCell>
                                            {t('asset.lowest_available_price')}
                                        </TableCell>
                                        <TableCell>
                                            <Link
                                                href={`/market/?term=${escape(
                                                    name,
                                                )}&collection=${
                                                    collection.collectionName
                                                }&schema=${schema}&order_by=offer_asc&limit=100${
                                                    attributeSearch
                                                        ? attributeSearch
                                                        : `&template_id=${template?.templateId}`
                                                }&exact_search=true`}
                                            >
                                                <div
                                                    className={
                                                        'text-primary hover:underline cursor-pointer break-all'
                                                    }
                                                >
                                                    {formatWAX(
                                                        template.stats[
                                                            'floorPrice'
                                                        ],
                                                    )}
                                                </div>
                                            </Link>
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    ''
                                )}
                                {template.stats['lastSold'] &&
                                template.stats['lastSold']['priceWax'] ? (
                                    // Last Sold
                                    <TableRow>
                                        <TableCell>
                                            {t('asset.last_sold')}
                                        </TableCell>
                                        <TableCell>
                                            <Link
                                                href={`/sale/${template.stats['lastSold']['listingId']}`}
                                            >
                                                <div
                                                    className={
                                                        'text-primary hover:underline cursor-pointer'
                                                    }
                                                >
                                                    {formatNumber(
                                                        template.stats[
                                                            'lastSold'
                                                        ]['priceWax'],
                                                    )}{' '}
                                                    WAX / $
                                                    {formatNumber(
                                                        template.stats[
                                                            'lastSold'
                                                        ]['priceUsd'],
                                                    )}
                                                </div>
                                            </Link>
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    ''
                                )}
                            </TableBody>
                        </Table>
                    </AccordionItem>
                </Accordion>
            ) : (
                ''
            )}
            {mData ? (
                <MarketPreviewDetailsTable
                    asset={asset}
                    dataTitle={'Mutable Data'}
                    newOwner={newOwner}
                    bundleView={false}
                    currentAsset={0}
                    assetData={mData}
                    className="none"
                    showDetails={false}
                    defaultExpandedKeys={['2']}
                />
            ) : null}
            {iData ? (
                <MarketPreviewDetailsTable
                    asset={asset}
                    dataTitle={'Immutable Data'}
                    newOwner={newOwner}
                    bundleView={false}
                    currentAsset={0}
                    assetData={iData}
                    className="none"
                    showDetails={false}
                    defaultExpandedKeys={['2']}
                />
            ) : null}
            {tData ? (
                <MarketPreviewDetailsTable
                    asset={asset}
                    dataTitle={'Template Data'}
                    newOwner={newOwner}
                    bundleView={false}
                    currentAsset={0}
                    assetData={tData}
                    className="none"
                    showDetails={false}
                    defaultExpandedKeys={['2']}
                />
            ) : null}
        </div>
    )
}

export default AssetDetails
